(function($) {

    $(".front-products-slider").owlCarousel({
        autoplay: true,
        items: 5,
        nav: true,
        loop: true,
        dots: false,
        dotsEach: 3,        
        responsive:{
            0:{
                items: 1,
            },
            600:{
                items:2
            },
            800:{
                items:5
            },
            1700:{
                items:5,
                nav: true,
                stagePadding: 20,
            }
        }
    });

    $(".front-trust-rep").owlCarousel({
        autoplay: true,
        autoplayTimeout: 2500,
        nav: false,        
        loop: true,
        dots: true,
        dotsEach: 3,
        responsive:{
            0:{
                items: 1
            },
            500:{
                items:2
            },

            800:{
                items:3
            },
            1000:{
                items:4
            }
        }
    });

	$(".front-guide-slider").owlCarousel({
        autoplay: true,
        autoplayTimeout: 2500,
        items: 3,
        nav: false,        
        loop: true,
        dots: true,
        dotsEach: 3,
        responsive:{
            0:{
                items: 1
            },
            500:{
                items:2
            },
            1000:{
                items:3
            },
            1400:{
                items:4
            }
        }
	});


})(jQuery);